module.exports = __webpack_public_path__ + "static/media/parking-slash.0b16f2f9.svg";